import React, { useContext } from "react";
import UswfButton from "../atoms/buttons/UswfButton";
import { NavigationContext } from "../context/NavigationContext";
import { openExternalLink } from '../util/openExternalLink';
import { navigateLink } from '../util/navigateLink';

const ChoiceButtons = ({
  content,
  navigationsAway,
  onPrimaryClick = () => {},
  onSecondaryClick = () => {},
  onTertiaryClick = () => {},
  onDangerClick = () => {},
}) => {
  const navigationContext = useContext(NavigationContext);

  const isKeyAChoice = (key) =>
    key === "firstChoice" ||
    key === "secondChoice" ||
    key === "thirdChoice" ||
    key === "fourthChoice" ||
    key === "fifthChoice" ||
    key === "sixthChoice" ||
    key === "seventhChoice" ||
    key === "eighthChoice" ||
    key === "buttonTitle";

  const sortChoices = (choice1, choice2) => {
    if (choice1 === "firstChoice") return -1;
    if (choice2 === "firstChoice") return 1;
    if (choice1 === "secondChoice") return -1;
    if (choice2 === "secondChoice") return 1;
    if (choice1 === "thirdChoice") return -1;
    if (choice2 === "thirdChoice") return 1;
    if (choice1 === "fourthChoice") return -1;
    if (choice2 === "fourthChoice") return 1;
    if (choice1 === "fifthChoice") return -1;
    if (choice2 === "fifthChoice") return 1;
    if (choice1 === "sixthChoice") return -1;
    if (choice2 === "sixthChoice") return 1;
    //for button title
    return 0;
  };

  const filteredContentList = Object.keys(content).filter(isKeyAChoice);
  filteredContentList.sort(sortChoices);
  const sortedContentList = filteredContentList.map((key) => content[key]);

  const handleClick = (index) => {
    if (index === 0) {
      onPrimaryClick();
      return navigateLink(navigationsAway.Primary, navigationContext);
    }
    if (index === 1) {
      onSecondaryClick();
      return navigateLink(navigationsAway.Secondary, navigationContext);
    }
    if (index === 2) {
      onTertiaryClick();
      return navigateLink(navigationsAway.Tertiary, navigationContext);
    }
    if (index === 3) {
      onDangerClick();
      return navigateLink(navigationsAway.Danger, navigationContext);
    }
    
    return navigateLink(navigationsAway.Primary, navigationContext);
  };

  return (
    <div className="button-group">
      {sortedContentList.map((contentItem, index) => (
        <UswfButton
          key={contentItem + index}
          onClick={() => handleClick(index)}
        >
          <span className="choice-button-label">{contentItem}</span>
        </UswfButton>
      ))}
    </div>
  );
};

export default ChoiceButtons;
